/**
 * The mobile nav module
 * 
 * @module mobileNav
 */
 (function () {

    var mobileNav = {};
    var mobileNavEvents = {};
    var mobileNavAnimating = false;

    /**
     * IE8 compatible function for replacing classes on a DOM node
     * 
     * @memberof module:mobileNav
     * @instance
     * @private
     *
     * @param  {object} element      - The DOM element we want to toggle classes on
     * @param  {object} state        - The current state of the animation on the element
     * @param  {string} openingClass - The firstClass you want to toggle on the DOM node
     * @param  {string} closingClass - The secondClass you want to toggle on the DOM node
     */
    function toggleClasses(element, state, openingClass, closingClass) {
        if (state === 'opening' || state === 'open') {
            var oldClass = openingClass || 'qhealth__main-nav__content--closed';
            var newClass = closingClass || 'qhealth__main-nav__content--open';
        } else {
            var oldClass = closingClass || 'qhealth__main-nav__content--open';
            var newClass = openingClass || 'qhealth__main-nav__content--closed';
        }

        removeClass(element, oldClass);
        addClass(element, newClass);
    }


    /**
     * IE8 compatible function for removing a class
     * 
     * @memberof module:mobileNav
     * @instance
     * @private
     *
     * @param  {object} element   - The DOM element we want to manipulate
     * @param  {object} className - The name of the class to be removed
     */
    function removeClass(element, className) {
        if (element.classList) {
            element.classList.remove(className);
        } else {
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }


    /**
     * IE8 compatible function for adding a class
     * 
     * @memberof module:mobileNav
     * @instance
     * @private
     *
     * @param  {object} element   - The DOM element we want to manipulate
     * @param  {object} className - The name of the class to be added
     */
    function addClass(element, className) {
        if (element.classList) {
            element.classList.add(className);
        } else {
            element.className = element.className + ' ' + className;
        }
    }


    /**
     * IE8 compatible function for adding an event
     * https://stackoverflow.com/questions/10149963/adding-event-listener-cross-browser
     * 
     * @memberof module:mobileNav
     * @instance
     * @private
     *
     * @param  {object} element    - The DOM element to add the listener
     * @param  {object} event      - The event data
     * @param  {object} rawHandler - The function to run when triggered
     *
     * @returns {object}           -  The token for removal of listener
     */
    function addEvent(element, event, rawHandler) {
        // Using local functions instead of anonymous for event handler
        function listenHandler(event) {
            var handler = rawHandler.apply(this, arguments);
            if (handler === false) {
                event.stopPropagation();
                event.preventDefault();
            }
            return (handler);
        }

        // Make sure attachHandler is also going to work
        function attachHandler() {
            var handler = rawHandler.call(element, window.event);
            if (handler === false) {
                window.event.returnValue = false;
                window.event.cancelBubble = true;
            }
            return (handler);
        }

        // Return the token and add the correct listener
        if (element.addEventListener) {
            element.addEventListener(event, listenHandler, false);
            return {
                element: element,
                handler: listenHandler,
                event: event
            };
        } else {
            element.attachEvent('on' + event, attachHandler);
            return {
                element: element,
                handler: attachHandler,
                event: event
            };
        }
    }


    /**
     * IE8 compatible function for removing an event
     * 
     * @memberof module:mobileNav
     * @instance
     * @private
     *
     * @param  {object} token - The token from the add listener function
     */
    function removeEvent(token) {
        if (token.element.removeEventListener) {
            token.element.removeEventListener(token.event, token.handler);
        } else {
            token.element.detachEvent('on' + token.event, token.handler);
        }
    }


    /**
     * IE8 compatible function for getting elements style
     * 
     * @memberof module:mobileNav
     * @instance
     * @private
     *
     * @param  {object} element  - element to check style
     * @param  {object} property - property to return value
     */
    function getStyle(element, property) {
        return (
            typeof getComputedStyle !== 'undefined' ?
            getComputedStyle(element, null) :
            element.currentStyle
        )[property]; // avoid getPropertyValue altogether
    }


    /**
     * Toggle a mobileNav element
     * 
     * @memberof module:mobileNav
     *
     * @param  {string}  element   - The toggle for the main nav
     * @param  {integer} speed     - The speed in ms for the animation
     * @param  {object}  callbacks - An object of four optional callbacks: { onOpen, afterOpen, onClose, afterClose }
     *
     */
    mobileNav.Toggle = function (element, speed, callbacks) {
        // Stop the main nav from being toggled if it is already being toggled
        if (mobileNavAnimating) {
            return;
        }

        mobileNavAnimating = true;

        // stop event propagation
        try {
            window.event.cancelBubble = true;
            event.stopPropagation();
        } catch (error) {}


        // check this once
        if (typeof callbacks != 'object') {
            callbacks = {};
        }


        // Elements we modify
        var targetId = element.getAttribute('aria-controls');
        var target = document.getElementById(targetId);
        var menu = target.querySelector('.qhealth__main-nav__menu');
        var overlay = target.querySelector('.qhealth__main-nav__overlay');
        var closeButton = target.querySelector('.qhealth__main-nav__toggle--close');
        var openButton = target.querySelector('.qhealth__main-nav__toggle--open');
        var focustrapTop = menu.querySelector('.qhealth__main-nav__focus-trap-top');
        var focustrapBottom = menu.querySelector('.qhealth__main-nav__focus-trap-bottom');
        var focusContent = menu.querySelectorAll('a, .qhealth__main-nav__toggle');
        var closed = target.className.indexOf('qhealth__main-nav__content--open') === -1;
        var header = document.querySelector('.qhealth__header');
        var body = document.querySelector('.main');
        var footer = document.querySelector('.qhealth__footer');

        var menuWidth = menu.offsetWidth;
        var state = closed ? 'opening' : '';

        overlay.style.display = 'block';


        (function (target, speed) {
            QH.animate.Toggle({
                element: menu,
                property: 'right',
                openSize: 0,
                closeSize: -1 * menuWidth,
                speed: speed || 250,
                prefunction: function () {
                    // Set these values immediately for transitions
                    if (state === 'opening') {
                        menu.style.display = 'block';
                        overlay.style.right = 0;
                        overlay.style.opacity = 0.5;

                        // run when opening
                        if (typeof callbacks.onOpen === 'function') {
                            callbacks.onOpen();
                        }
                    } else {
                        overlay.style.opacity = '0';

                        // run when closing
                        if (typeof callbacks.onClose === 'function') {
                            callbacks.onClose();
                        }
                    }
                },
                postfunction: function () {
                    if (state === 'opening' ) {

                        // Move the focus to the close button
                        closeButton.focus();
                        openButton.setAttribute('aria-expanded', true);
                        closeButton.setAttribute('aria-expanded', true);

                        // Focus trap enabled
                        focustrapTop.setAttribute('tabindex', 0);
                        focustrapBottom.setAttribute('tabindex', 0);

                        header.setAttribute('aria-hidden', true);
                        body.setAttribute('aria-hidden', true);
                        footer.setAttribute('aria-hidden', true);

                        // Add event listeners
                        mobileNavEvents.focusTop = addEvent(focustrapTop, 'focus', function () {
                            focusContent[focusContent.length - 1].focus();
                        });

                        mobileNavEvents.focusBottom = addEvent(focustrapBottom, 'focus', function () {
                            focusContent[0].focus();
                        });

                        // Add key listener
                        mobileNavEvents.escKey = addEvent(document, 'keyup', function () {
                            var event = event || window.event;
                            var overlayOpen = getStyle(overlay, 'display');

                            // Check the menu is open and visible and the escape key is pressed
                            if (event.keyCode === 27 && overlayOpen === 'block') {
                                mobileNav.Toggle(element, speed, callbacks);
                            }
                        });


                        if (typeof callbacks.afterOpen === 'function') {
                            callbacks.afterOpen();
                        }
                    } else {
                        // Move the focus back to the menu button
                        openButton.focus();
                        openButton.setAttribute('aria-expanded', false);
                        closeButton.setAttribute('aria-expanded', false);

                        // Remove the focus trap
                        focustrapTop.removeAttribute('tabindex');
                        focustrapBottom.removeAttribute('tabindex');

                        header.removeAttribute('aria-hidden');
                        body.removeAttribute('aria-hidden');
                        footer.removeAttribute('aria-hidden');


                        // Remove the event listeners
                        removeEvent(mobileNavEvents.focusTop);
                        removeEvent(mobileNavEvents.focusBottom);


                        // Remove the event listener for the keypress
                        removeEvent(mobileNavEvents.escKey);

                        if (typeof callbacks.afterClose === 'function') {
                            callbacks.afterClose();
                        }
                    }


                    // Toggle classes
                    toggleClasses(target, state);
                    toggleClasses(
                        document.body,
                        state,
                        'qhealth__main-nav__scroll--unlocked',
                        'qhealth__main-nav__scroll--locked'
                    );


                    // Reset inline styles
                    menu.style.display = '';
                    menu.style.right = '';
                    overlay.style.display = '';
                    overlay.style.right = '';
                    overlay.style.opacity = '';

                    mobileNavAnimating = false;
                },
            });
        })(target, speed);
    }

   
    window.addEventListener('DOMContentLoaded', function () {
        //console.log('nav initted')
        // Add toggle event to open mobile nav
        var navToggles = document.querySelectorAll('*[aria-controls="main-nav"]');
        navToggles.forEach(function (button) {
            button.addEventListener('click', function () {
                mobileNav.Toggle(button);
            });
        });

         // Add toggle event listeners to accordion buttons
        var itemToggles = document.querySelectorAll('.qhealth__main-nav__item-toggle');
        //const bodyHTML = document.querySelector('body');
        itemToggles.forEach(function(button) {
            button.addEventListener('click', function () {   
                // add event to body to close menu if clicking outside of menu
                document.addEventListener('click', handleOffMenuClick);     
                // handle menu click
                if(button.className.split(' ').indexOf('qhealth__accordion--closed')>=0){                    
                    button.parentNode.querySelector('.qhealth__main-nav__item-link').classList.add('qhealth____main-nav__item-link--open');
                    itemToggles.forEach(function (item) {
                        if(item.className.split(' ').indexOf('qhealth__accordion--open')>=0){
                            item.parentNode.querySelector('.qhealth__main-nav__item-link').classList.remove('qhealth____main-nav__item-link--open');
                            QH.accordion.Close(item);
                        }
                    });
                }else{
                    button.parentNode.querySelector('.qhealth__main-nav__item-link').classList.remove('qhealth____main-nav__item-link--open');
                }


                QH.accordion.Toggle(button);
            });
        });
    });

    const handleOffMenuClick = (event) => {
        
        const target = event.target.closest('.qhealth__main-nav__item') || null;
        if(target === null){
            //const bodyHTML = document.querySelector('body');
            document.removeEventListener('click', handleOffMenuClick);
            const itemToggles = document.querySelectorAll('.qhealth__main-nav__item-toggle');
            itemToggles.forEach(function (item) {
                if(item.className.split(' ').indexOf('qhealth__accordion--open')>=0){
                    item.parentNode.querySelector('.qhealth__main-nav__item-link').classList.remove('qhealth____main-nav__item-link--open');
                    QH.accordion.Close(item);
                }
            });
        }

    } 

}());


(function () {
   
    /**
     * The mega menu module
     * 
     * @module megaMenu
     */
    var megaMenu = {

        /**
         * Initialise the mega menu listeners for keyboard navigation
         * 
         * @memberof module:megaMenu
         */
        'init': function () {

            // Top level items
            var topNavItems = document.querySelectorAll('.qhealth__main-nav__item-title > a');
            topNavItems.forEach(function (item) {
                item.addEventListener('keydown', handleTopNavKeydown);
                item.addEventListener('focusin', toggleMenu);
                item.addEventListener('focusout', handleTopNavFocusout);
            });

            // Mega menu items
            var menuItems = document.querySelectorAll('.qhealth__main-nav__menu-sub a');
            menuItems.forEach(function (item) {
                item.addEventListener('keydown', handleMenuKeypress);
            });
        
        },

    };

    /**
     * Handle keydown on top level nav item to close the menu
     * if ESCAPE or UP key are pressed
     * 
     * @memberof module:megaMenu
     * @instance
     * @private
     * 
     * @param {Document.event} e 
     */
    function handleTopNavKeydown(e) {
        var key = e.keyCode;

        // ESC or UP ARROW
        if (key === 27 || key == 38) {
            toggleMenu(e);
        }
    }

    /**
     * Handle focusout of top level nav items.
     * Close the menu, unless we have tabbed within
     * 
     * @memberof module:megaMenu
     * @instance
     * @private
     * 
     * @param {Document.event} e 
     */
    function handleTopNavFocusout(e) {
        var link = e.target;
        var navItem = link.closest('.qhealth__main-nav__item');
        var expanded = navItem.classList.contains('expanded') ? true : false;
        var menu = navItem.querySelector('.qhealth__main-nav__menu-sub');
        
        // Short delay to ensure we are on the new active element
        // Close the menu, unless we have tabbed within
        setTimeout(function() {
            var menuHasFocus = menu.contains(document.activeElement) ? true : false;
            if (!menuHasFocus && expanded) {
                toggleMenu(e);
            }
        }, 20);
    }

    /**
     * Toggle the mega menu open/closed
     * 
     * @memberof module:megaMenu
     * @instance
     * @private
     * 
     * @param {Document.event} e 
     */
    function toggleMenu(e) {
        var link = e.target;
        var navItem = link.closest('.qhealth__main-nav__item');
        var expanded = navItem.classList.contains('expanded') ? true : false;

        if (!expanded) {
            navItem.classList.add('expanded');
            setTimeout(function() {
                document.addEventListener('click', handleBackgroundClick);
            }, 30);
        } else {
            navItem.classList.remove('expanded');
            document.removeEventListener('click', handleBackgroundClick);
        }
    }

    /**
     * Close the mega menu if the user clicks outside of it while opened
     * 
     * @memberof module:megaMenu
     * @instance
     * @private
     * 
     * @param {Document.event} e 
     */
    function handleBackgroundClick(e) {
        var target = e.target;
        var nav = document.querySelector('.qhealth__main-nav__menu-inner');

        // If clicked outside nav
        if (!nav.contains(target)) {

            // Close any expanded menu(s)
            document.querySelectorAll('.qhealth__main-nav__item.expanded').forEach(function(item) {
                item.classList.remove('expanded');
            });

            // Remove listener
            document.removeEventListener('click', handleBackgroundClick);
        }
    }

    /**
     * Handle keypress for item within mega menu.
     * Close the menu on press of ESCAPE or UP
     * After TAB press, check if focus is still within menu,
     * and close if it's not
     * 
     * @memberof module:megaMenu
     * @instance
     * @private
     * 
     * @param {Document.event} e 
     */
    function handleMenuKeypress(e) {
        var link = e.target;
        var key = e.keyCode;
        var navItem = link.closest('.qhealth__main-nav__item');
        var menu = link.closest('.qhealth__main-nav__menu-sub');

        // ESC or UP ARROW
        if (key === 27 || key == 38) {
            navItem.querySelector('.qhealth__main-nav__item-title > a').focus();
        }

        // If TAB key is pressed only (not SHIFT + TAB)
        if (key === 9 && !e.shiftKey) {
            setTimeout(function() {
                var menuHasFocus = menu.contains(document.activeElement) ? true : false;
                if (!menuHasFocus) {
                    toggleMenu(e);
                }
            }, 20);
        }
        
    }

    window.addEventListener('DOMContentLoaded', function () {
        megaMenu.init();
    });

}());
